import { useSetAtom } from "jotai";
import { useEffect } from "react";

import { useAdvertisementCampaignConfig } from "~/components/advertisement/campaign/hooks";
import { useAdvertisementConfig } from "~/components/advertisement/hooks";
import { appAtom } from "~/lib/app/atoms";
import { useIpGeoLocation } from "~/lib/hooks";

export const useAppSetup = () => {
  const setApp = useSetAtom(appAtom);

  const { config: advertisementConfig, loaded: advertisementCampaignConfigLoaded } =
    useAdvertisementConfig();
  const { config: advertisementCampaignConfig, loaded: advertisementConfigLoaded } =
    useAdvertisementCampaignConfig();
  const ipGeoLocation = useIpGeoLocation();

  useEffect(() => {
    setApp({
      advertisementCampaignConfig,
      advertisementCampaignConfigLoaded,
      advertisementConfig,
      advertisementConfigLoaded,
      ipGeoLocation,
    });
  }, [
    advertisementCampaignConfig,
    advertisementCampaignConfigLoaded,
    advertisementConfig,
    advertisementConfigLoaded,
    ipGeoLocation,
    setApp,
  ]);
};
